import { useQuery } from "react-query";
import VendorManagerServices from "../services/API/VendorManager";

// All vendors (Alliance Manager screens: vendor pickers, vendor name lookups)
export const useVendors = () => {
  const { data: vendorList, isLoading } = useQuery(
    ["/api/vendor/list", { limit: 1000, page: 1 }],
    VendorManagerServices.getAllVendor,
    { refetchOnWindowFocus: false }
  );
  return { vendors: vendorList?.data?.data, isLoading };
};

// Active (approved) and enabled vendors only
export const useActiveVendors = () => {
  const { vendors, isLoading } = useVendors();
  return {
    vendors: vendors?.filter(
      (vendor) => vendor?.status == 1 && vendor?.is_enabled == 1
    ),
    isLoading,
  };
};
